var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessPresentationReportMeetingFinanceSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27,2H5C3.3,2,2,3.3,2,5v2c0,0.6,0.4,1,1,1v12c0,1.7,1.3,3,3,3h7.8l-5.5,6.3c-0.4,0.4-0.3,1,0.1,1.4C8.5,30.9,8.8,31,9,31 c0.3,0,0.6-0.1,0.8-0.3l5.2-6V29c0,0.6,0.4,1,1,1s1-0.4,1-1v-4.3l5.2,6c0.2,0.2,0.5,0.3,0.8,0.3c0.2,0,0.5-0.1,0.7-0.2 c0.4-0.4,0.5-1,0.1-1.4L18.2,23H26c1.7,0,3-1.3,3-3V8c0.6,0,1-0.4,1-1V5C30,3.3,28.7,2,27,2z M27,20c0,0.6-0.4,1-1,1H6 c-0.6,0-1-0.4-1-1V8h22V20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,9.1V13h3.9C17.5,11,16,9.5,14,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,19c2.4,0,4.4-1.7,4.9-4H13c-0.6,0-1-0.4-1-1V9.1C9.7,9.6,8,11.6,8,14C8,16.8,10.2,19,13,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,13h3c0.6,0,1-0.4,1-1s-0.4-1-1-1h-3c-0.6,0-1,0.4-1,1S19.4,13,20,13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,17h3c0.6,0,1-0.4,1-1s-0.4-1-1-1h-3c-0.6,0-1,0.4-1,1S19.4,17,20,17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessPresentationReportMeetingFinanceSvgrepoCom);
export default __webpack_public_path__ + "static/media/business-presentation-report-meeting-finance-svgrepo-com.ede00c1d53bc7862960f0dffdfd2f027.svg";
export { ForwardRef as ReactComponent };